import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

/**
 * Permanently deletes the authenticated user's account and all their personal
 * data (the server cascades the deletion). Required by App Store guideline
 * 5.1.1(v). The endpoint (`DELETE /accounts/me`) requires the account password
 * as a confirmation in the body and returns 401 if it is wrong. The caller is
 * responsible for signing the user out once this resolves.
 */
export const deleteAccount = async (password: string): Promise<void> => {
  await api.delete('/accounts/me', { data: { password } })
}

export const useDeleteAccount = () =>
  useMutation<void, Error, string>({
    mutationFn: deleteAccount,
  })
